export default __webpack_public_path__ + "static/media/orange.3785e6b6.png";